import { TranslationKey } from "../i18n/translation-key"

export enum BikeForSaleType {
  NEW = "NEW",
  SECOND_HAND = "SECOND_HAND",
}

export const BIKE_FOR_SALE_TYPE_LABEL_KEYS: Record<
  BikeForSaleType,
  TranslationKey
> = {
  [BikeForSaleType.NEW]: "common.bikeForSaleType.new",
  [BikeForSaleType.SECOND_HAND]: "common.bikeForSaleType.secondHand",
}
